import React from 'react';
import { VehicleType } from '../../common/CommonTypes';
import './SelectableVehicles.scss';
import { t } from 'i18next';

export type VehicleProps = {
    id: string;
    vehicle: VehicleType;
};

const Vehicle = ({ id, vehicle }: VehicleProps): JSX.Element => {
    const { vrn, vin, make, model } = vehicle;

    return (
        <div
            id={id}
            data-testid='vehicle-container'
            className='vehicle--container'>
            <section className='vehicle--info'>
                <b>{t('vreg')}</b>
                {vrn}
                <br />
                <b>{t('vin')}</b>
                {vin}
                <br />
                <b>{t('make')}</b>
                {make}
                <br />
                <b>{t('model')}</b>
                {model}
            </section>
        </div>
    );
};

export default Vehicle;
